import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DashboardCardComponent } from '../dashboard-card/dashboard-card.component';

interface RevenueSummaryRow {
   label: string;
   day: number;
   lastYear: number;
   budget: number;
}

@Component({
   selector: 'app-dashboard-revenue-summary',
   standalone: true,
   imports: [CommonModule, DashboardCardComponent],
   templateUrl: './revenue-summary.component.html',
   styleUrls: ['./revenue-summary.component.scss']
})
export class RevenueSummaryComponent {
   @Input() dateLabel: string | null = null;

   readonly rows: RevenueSummaryRow[] = [
      {
         label: 'Total',
         day: 23680,
         lastYear: 19772,
         budget: 22500
      },
      {
         label: 'Rooms',
         day: 17860,
         lastYear: 16900,
         budget: 17500
      },
      {
         label: 'F&B',
         day: 4340,
         lastYear: 858,
         budget: 3800
      },
      {
         label: 'Other',
         day: 1480,
         lastYear: 2014,
         budget: 1200
      }
   ];
}
